<div class="popup-form wf-section">
  <button class="closedialog" (click)="fn_CloseDialog()">
    <i class="material-icons">close</i>
  </button>
  <div class="container">
    <div class="hero-title-center flex-inner">
      <div>
        <h2 class="hero-title _50px">
          Forgot <span class="add-scribble-below">Password</span>
          <span class="add-scribble-below"></span><br>
        </h2>
        <div class="margin-20px">
          <p>Forgotten your password? Not a problem. Enter your email address and we&#x27;ll send you an email with instructions for resetting it.<br></p>
        </div>
      </div>
    </div>
    <div class="margin-50px">
      <div class="w-form">
        <form [formGroup]="forgotPassForm" (ngSubmit)="onSubmit(forgotPassForm)" id="forgot-email-form" name="forgot-email-form" data-name="Forgot Email Form" class="form schelude">
          <input formControlName="ForgetPasswordEmailId" id="ForgetPasswordEmailId"
                 type="email" class="text-field margin-bottom w-node-_6bc99137-51a2-55f9-ea62-62292b9d471d-d5529654 w-input"
                 maxlength="256" name="Email" data-name="Email" placeholder="Enter your email" required="">
          <div *ngIf="f.ForgetPasswordEmailId.touched && f.ForgetPasswordEmailId.invalid && f.ForgetPasswordEmailId.pristine" class="error-message">
            <div>Email is required.</div>
          </div>
          <div *ngIf="!f.ForgetPasswordEmailId.valid && (!f.ForgetPasswordEmailId.hasError('pattern') && f.ForgetPasswordEmailId.touched && f.ForgetPasswordEmailId.dirty)" class="error-message">
            <div>Email is required.</div>
          </div>
          <div *ngIf="!f.ForgetPasswordEmailId.valid && (f.ForgetPasswordEmailId.hasError('pattern') && f.ForgetPasswordEmailId.dirty)" class="error-message">
            <div>Invalid Email.</div>
          </div>
          <div>
            <input cdkFocusInitial [disabled]="forgotPassForm.invalid" type="submit" value="Reset Password →" data-wait="Please wait..." class="button subscribe orange full-button w-button">
          </div>
        
          <div class="margin-20px">
            <p class="cookies-font">
              Already have an account? <a (click)="openloginFormDialog()" class="anchor-underline">Sign In</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div><img src="assets/img/scribbles-3.png" width="60" data-w-id="6bc99137-51a2-55f9-ea62-62292b9d4736" sizes="(max-width: 479px) 100vw, (max-width: 991px) 40px, 60px" srcset="assets/img/scribbles-3-p-500.png 500w, assets/img/scribbles-3.png 608w" alt="" class="scribble-2"><img src="assets/img/scribbles-8.png" width="600" data-w-id="6bc99137-51a2-55f9-ea62-62292b9d4737" sizes="(max-width: 767px) 100px, (max-width: 991px) 200px, 400px" srcset="assets/img/scribbles-8-p-500.png 500w, assets/img/scribbles-8-p-800.png 800w, assets/img/scribbles-8-p-1080.png 1080w, assets/img/scribbles-8-p-1600.png 1600w, assets/img/scribbles-8.png 2287w" alt="" class="scribble-4">
</div>
